var _path, _g, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 63,
    viewBox: "0 0 57 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_30185)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_125_30185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_125_30185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 54,
    height: 54
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.6 31.8C55.6 46.6 43.6 58.6 28.8 58.6C14 58.6 2 46.6 2 31.8C2 17 14 5 28.8 5C43.6 5 55.6 17 55.6 31.8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_125_30185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.7004 1.19922H-25.0996V63.7992H82.7004V1.19922Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.90039 63.7994L-1.09961 53.3994H10.8004L4.90039 63.7994L-1.09961 53.3994H10.8004L4.90039 63.7994Z",
    fill: "url(#paint0_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90039 53.3994L-1.09961 42.8994H10.8004L4.90039 53.3994L-1.09961 42.8994H10.8004L4.90039 53.3994Z",
    fill: "url(#paint1_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90039 42.9L-1.09961 32.5H10.8004L4.90039 42.9L-1.09961 32.5H10.8004L4.90039 42.9Z",
    fill: "url(#paint2_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90039 32.5L-1.09961 22H10.8004L4.90039 32.5L-1.09961 22H10.8004L4.90039 32.5Z",
    fill: "url(#paint3_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90039 22L-1.09961 11.5H10.8004L4.90039 22L-1.09961 11.5H10.8004L4.90039 22Z",
    fill: "url(#paint4_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90039 11.4996L-1.09961 1.09961H10.8004L4.90039 11.4996L-1.09961 1.09961H10.8004L4.90039 11.4996Z",
    fill: "url(#paint5_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 63.7994L10.8008 53.3994H22.8008L16.8008 63.7994L10.8008 53.3994H22.8008L16.8008 63.7994Z",
    fill: "url(#paint6_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 53.3994L10.8008 42.8994H22.8008L16.8008 53.3994L10.8008 42.8994H22.8008L16.8008 53.3994Z",
    fill: "url(#paint7_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 42.9L10.8008 32.5H22.8008L16.8008 42.9L10.8008 32.5H22.8008L16.8008 42.9Z",
    fill: "url(#paint8_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 32.5L10.8008 22H22.8008L16.8008 32.5L10.8008 22H22.8008L16.8008 32.5Z",
    fill: "url(#paint9_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 22L10.8008 11.5H22.8008L16.8008 22L10.8008 11.5H22.8008L16.8008 22Z",
    fill: "url(#paint10_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 11.4996L10.8008 1.09961H22.8008L16.8008 11.4996L10.8008 1.09961H22.8008L16.8008 11.4996Z",
    fill: "url(#paint11_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 63.7994L22.8008 53.3994H34.8008L28.8008 63.7994L22.8008 53.3994H34.8008L28.8008 63.7994Z",
    fill: "url(#paint12_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 53.3994L22.8008 42.8994H34.8008L28.8008 53.3994L22.8008 42.8994H34.8008L28.8008 53.3994Z",
    fill: "url(#paint13_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 42.9L22.8008 32.5H34.8008L28.8008 42.9L22.8008 32.5H34.8008L28.8008 42.9Z",
    fill: "url(#paint14_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 32.5L22.8008 22H34.8008L28.8008 32.5L22.8008 22H34.8008L28.8008 32.5Z",
    fill: "url(#paint15_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 22L22.8008 11.5H34.8008L28.8008 22L22.8008 11.5H34.8008L28.8008 22Z",
    fill: "url(#paint16_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 11.4996L22.8008 1.09961H34.8008L28.8008 11.4996L22.8008 1.09961H34.8008L28.8008 11.4996Z",
    fill: "url(#paint17_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8008 63.7994L34.8008 53.3994H46.8008L40.8008 63.7994L34.8008 53.3994H46.8008L40.8008 63.7994Z",
    fill: "url(#paint18_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8008 53.3994L34.8008 42.8994H46.8008L40.8008 53.3994L34.8008 42.8994H46.8008L40.8008 53.3994Z",
    fill: "url(#paint19_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8008 42.9L34.8008 32.5H46.8008L40.8008 42.9L34.8008 32.5H46.8008L40.8008 42.9Z",
    fill: "url(#paint20_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8008 32.5L34.8008 22H46.8008L40.8008 32.5L34.8008 22H46.8008L40.8008 32.5Z",
    fill: "url(#paint21_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8008 22L34.8008 11.5H46.8008L40.8008 22L34.8008 11.5H46.8008L40.8008 22Z",
    fill: "url(#paint22_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8008 11.4996L34.8008 1.09961H46.8008L40.8008 11.4996L34.8008 1.09961H46.8008L40.8008 11.4996Z",
    fill: "url(#paint23_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 63.7994L46.8008 53.3994H58.8008L52.8008 63.7994L46.8008 53.3994H58.8008L52.8008 63.7994Z",
    fill: "url(#paint24_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 53.3994L46.8008 42.8994H58.8008L52.8008 53.3994L46.8008 42.8994H58.8008L52.8008 53.3994Z",
    fill: "url(#paint25_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 42.9L46.8008 32.5H58.8008L52.8008 42.9L46.8008 32.5H58.8008L52.8008 42.9Z",
    fill: "url(#paint26_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 32.5L46.8008 22H58.8008L52.8008 32.5L46.8008 22H58.8008L52.8008 32.5Z",
    fill: "url(#paint27_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 22L46.8008 11.5H58.8008L52.8008 22L46.8008 11.5H58.8008L52.8008 22Z",
    fill: "url(#paint28_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 11.4996L46.8008 1.09961H58.8008L52.8008 11.4996L46.8008 1.09961H58.8008L52.8008 11.4996Z",
    fill: "url(#paint29_linear_125_30185)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 1.09961L58.8008 11.5996H46.8008L52.8008 1.09961L58.8008 11.5996H46.8008L52.8008 1.09961Z",
    fill: "url(#paint30_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 11.5996L58.8008 21.9996H46.8008L52.8008 11.5996L58.8008 21.9996H46.8008L52.8008 11.5996Z",
    fill: "url(#paint31_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 22L58.8008 32.5H46.8008L52.8008 22L58.8008 32.5H46.8008L52.8008 22Z",
    fill: "url(#paint32_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 32.5L58.8008 42.9H46.8008L52.8008 32.5L58.8008 42.9H46.8008L52.8008 32.5Z",
    fill: "url(#paint33_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 42.8994L58.8008 53.3994H46.8008L52.8008 42.8994L58.8008 53.3994H46.8008L52.8008 42.8994Z",
    fill: "url(#paint34_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8008 53.3994L58.8008 63.7994H46.8008L52.8008 53.3994L58.8008 63.7994H46.8008L52.8008 53.3994Z",
    fill: "url(#paint35_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8008 1.09961L46.8008 11.5996H34.8008L40.8008 1.09961L46.8008 11.5996H34.8008L40.8008 1.09961Z",
    fill: "url(#paint36_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8008 11.5996L46.8008 21.9996H34.8008L40.8008 11.5996L46.8008 21.9996H34.8008L40.8008 11.5996Z",
    fill: "url(#paint37_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8008 22L46.8008 32.5H34.8008L40.8008 22L46.8008 32.5H34.8008L40.8008 22Z",
    fill: "url(#paint38_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8008 32.5L46.8008 42.9H34.8008L40.8008 32.5L46.8008 42.9H34.8008L40.8008 32.5Z",
    fill: "url(#paint39_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8008 42.8994L46.8008 53.3994H34.8008L40.8008 42.8994L46.8008 53.3994H34.8008L40.8008 42.8994Z",
    fill: "url(#paint40_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8008 53.3994L46.8008 63.7994H34.8008L40.8008 53.3994L46.8008 63.7994H34.8008L40.8008 53.3994Z",
    fill: "url(#paint41_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 1.09961L34.8008 11.5996H22.8008L28.8008 1.09961L34.8008 11.5996H22.8008L28.8008 1.09961Z",
    fill: "url(#paint42_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 11.5996L34.8008 21.9996H22.8008L28.8008 11.5996L34.8008 21.9996H22.8008L28.8008 11.5996Z",
    fill: "url(#paint43_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 22L34.8008 32.5H22.8008L28.8008 22L34.8008 32.5H22.8008L28.8008 22Z",
    fill: "url(#paint44_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 32.5L34.8008 42.9H22.8008L28.8008 32.5L34.8008 42.9H22.8008L28.8008 32.5Z",
    fill: "url(#paint45_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 42.8994L34.8008 53.3994H22.8008L28.8008 42.8994L34.8008 53.3994H22.8008L28.8008 42.8994Z",
    fill: "url(#paint46_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8008 53.3994L34.8008 63.7994H22.8008L28.8008 53.3994L34.8008 63.7994H22.8008L28.8008 53.3994Z",
    fill: "url(#paint47_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 1.09961L22.8008 11.5996H10.8008L16.8008 1.09961L22.8008 11.5996H10.8008L16.8008 1.09961Z",
    fill: "url(#paint48_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 11.5996L22.8008 21.9996H10.8008L16.8008 11.5996L22.8008 21.9996H10.8008L16.8008 11.5996Z",
    fill: "url(#paint49_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 22L22.8008 32.5H10.8008L16.8008 22L22.8008 32.5H10.8008L16.8008 22Z",
    fill: "url(#paint50_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 32.5L22.8008 42.9H10.8008L16.8008 32.5L22.8008 42.9H10.8008L16.8008 32.5Z",
    fill: "url(#paint51_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 42.8994L22.8008 53.3994H10.8008L16.8008 42.8994L22.8008 53.3994H10.8008L16.8008 42.8994Z",
    fill: "url(#paint52_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8008 53.3994L22.8008 63.7994H10.8008L16.8008 53.3994L22.8008 63.7994H10.8008L16.8008 53.3994Z",
    fill: "url(#paint53_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90039 1.09961L10.8004 11.5996H-1.09961L4.90039 1.09961L10.8004 11.5996H-1.09961L4.90039 1.09961Z",
    fill: "url(#paint54_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90039 11.5996L10.8004 21.9996H-1.09961L4.90039 11.5996L10.8004 21.9996H-1.09961L4.90039 11.5996Z",
    fill: "url(#paint55_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90039 22L10.8004 32.5H-1.09961L4.90039 22L10.8004 32.5H-1.09961L4.90039 22Z",
    fill: "url(#paint56_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90039 32.5L10.8004 42.9H-1.09961L4.90039 32.5L10.8004 42.9H-1.09961L4.90039 32.5Z",
    fill: "url(#paint57_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90039 42.8994L10.8004 53.3994H-1.09961L4.90039 42.8994L10.8004 53.3994H-1.09961L4.90039 42.8994Z",
    fill: "url(#paint58_linear_125_30185)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.90039 53.3994L10.8004 63.7994H-1.09961L4.90039 53.3994L10.8004 63.7994H-1.09961L4.90039 53.3994Z",
    fill: "url(#paint59_linear_125_30185)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.7004 1.19922H-25.0996V63.7992H82.7004V1.19922Z",
    fill: "url(#paint60_radial_125_30185)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5004 24.7996L13.4004 18.5996H19.5004L22.6004 24.7996H16.5004Z",
    fill: "url(#paint61_linear_125_30185)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8 49.3994L19.5 30.8994H25.7L28.8 37.0994L31.9 30.8994H38L28.8 49.3994Z",
    fill: "url(#paint62_linear_125_30185)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35 24.7996L38 18.5996H44.2L41.1 24.7996H35Z",
    fill: "url(#paint63_linear_125_30185)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_125_30185",
    x: -2,
    y: 5,
    width: 61.6001,
    height: 61.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_125_30185"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_125_30185",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_125_30185",
    x1: 10.8496,
    y1: 58.5761,
    x2: -1.13321,
    y2: 58.5761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_125_30185",
    x1: 10.8496,
    y1: 48.1257,
    x2: -1.13321,
    y2: 48.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_125_30185",
    x1: 10.8496,
    y1: 37.676,
    x2: -1.13321,
    y2: 37.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_125_30185",
    x1: 10.8496,
    y1: 27.2256,
    x2: -1.13321,
    y2: 27.2256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_125_30185",
    x1: 10.8496,
    y1: 16.7752,
    x2: -1.13321,
    y2: 16.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_125_30185",
    x1: 10.8496,
    y1: 6.32461,
    x2: -1.13321,
    y2: 6.32461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_125_30185",
    x1: 22.8328,
    y1: 58.5761,
    x2: 10.85,
    y2: 58.5761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_125_30185",
    x1: 22.8328,
    y1: 48.1257,
    x2: 10.85,
    y2: 48.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_125_30185",
    x1: 22.8328,
    y1: 37.676,
    x2: 10.85,
    y2: 37.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_125_30185",
    x1: 22.8328,
    y1: 27.2256,
    x2: 10.85,
    y2: 27.2256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_125_30185",
    x1: 22.8328,
    y1: 16.7752,
    x2: 10.85,
    y2: 16.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_125_30185",
    x1: 22.8328,
    y1: 6.32461,
    x2: 10.85,
    y2: 6.32461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_125_30185",
    x1: 34.8159,
    y1: 58.5761,
    x2: 22.8328,
    y2: 58.5761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_125_30185",
    x1: 34.8159,
    y1: 48.1257,
    x2: 22.8328,
    y2: 48.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_125_30185",
    x1: 34.8159,
    y1: 37.676,
    x2: 22.8328,
    y2: 37.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_125_30185",
    x1: 34.8159,
    y1: 27.2256,
    x2: 22.8328,
    y2: 27.2256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_125_30185",
    x1: 34.8159,
    y1: 16.7752,
    x2: 22.8328,
    y2: 16.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_125_30185",
    x1: 34.8159,
    y1: 6.32461,
    x2: 22.8328,
    y2: 6.32461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_125_30185",
    x1: 46.7987,
    y1: 58.5761,
    x2: 34.8159,
    y2: 58.5761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_125_30185",
    x1: 46.7987,
    y1: 48.1257,
    x2: 34.8159,
    y2: 48.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_125_30185",
    x1: 46.7987,
    y1: 37.676,
    x2: 34.8159,
    y2: 37.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_125_30185",
    x1: 46.7987,
    y1: 27.2256,
    x2: 34.8159,
    y2: 27.2256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_125_30185",
    x1: 46.7987,
    y1: 16.7752,
    x2: 34.8159,
    y2: 16.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_125_30185",
    x1: 46.7987,
    y1: 6.32461,
    x2: 34.8159,
    y2: 6.32461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_125_30185",
    x1: 58.782,
    y1: 58.5761,
    x2: 46.7987,
    y2: 58.5761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_125_30185",
    x1: 58.782,
    y1: 48.1257,
    x2: 46.7987,
    y2: 48.1257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_125_30185",
    x1: 58.782,
    y1: 37.676,
    x2: 46.7987,
    y2: 37.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_125_30185",
    x1: 58.782,
    y1: 27.2256,
    x2: 46.7987,
    y2: 27.2256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_125_30185",
    x1: 58.782,
    y1: 16.7752,
    x2: 46.7987,
    y2: 16.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_125_30185",
    x1: 58.782,
    y1: 6.32461,
    x2: 46.7987,
    y2: 6.32461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1A1A",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3518,
    stopColor: "#262626",
    stopOpacity: 0.4675
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#333333",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_125_30185",
    x1: 58.7816,
    y1: 6.32491,
    x2: 46.7987,
    y2: 6.32491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_125_30185",
    x1: 58.7816,
    y1: 16.7752,
    x2: 46.7987,
    y2: 16.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_125_30185",
    x1: 58.7816,
    y1: 27.2257,
    x2: 46.7987,
    y2: 27.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_125_30185",
    x1: 58.7816,
    y1: 37.6761,
    x2: 46.7987,
    y2: 37.6761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_125_30185",
    x1: 58.7816,
    y1: 48.1262,
    x2: 46.7987,
    y2: 48.1262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_125_30185",
    x1: 58.7816,
    y1: 58.5764,
    x2: 46.7987,
    y2: 58.5764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_125_30185",
    x1: 46.7987,
    y1: 6.32491,
    x2: 34.8159,
    y2: 6.32491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_125_30185",
    x1: 46.7987,
    y1: 16.7752,
    x2: 34.8159,
    y2: 16.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_125_30185",
    x1: 46.7987,
    y1: 27.2257,
    x2: 34.8159,
    y2: 27.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_125_30185",
    x1: 46.7987,
    y1: 37.6761,
    x2: 34.8159,
    y2: 37.6761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_125_30185",
    x1: 46.7987,
    y1: 48.1262,
    x2: 34.8159,
    y2: 48.1262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_125_30185",
    x1: 46.7987,
    y1: 58.5764,
    x2: 34.8159,
    y2: 58.5764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_125_30185",
    x1: 34.8159,
    y1: 6.32491,
    x2: 22.8328,
    y2: 6.32491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_125_30185",
    x1: 34.8159,
    y1: 16.7752,
    x2: 22.8328,
    y2: 16.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_125_30185",
    x1: 34.8159,
    y1: 27.2257,
    x2: 22.8328,
    y2: 27.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_125_30185",
    x1: 34.8159,
    y1: 37.6761,
    x2: 22.8328,
    y2: 37.6761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_125_30185",
    x1: 34.8159,
    y1: 48.1262,
    x2: 22.8328,
    y2: 48.1262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_125_30185",
    x1: 34.8159,
    y1: 58.5764,
    x2: 22.8328,
    y2: 58.5764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_125_30185",
    x1: 22.8328,
    y1: 6.32491,
    x2: 10.8498,
    y2: 6.32491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_125_30185",
    x1: 22.8328,
    y1: 16.7752,
    x2: 10.8498,
    y2: 16.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_125_30185",
    x1: 22.8328,
    y1: 27.2257,
    x2: 10.8498,
    y2: 27.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_125_30185",
    x1: 22.8328,
    y1: 37.6761,
    x2: 10.8498,
    y2: 37.6761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_125_30185",
    x1: 22.8328,
    y1: 48.1262,
    x2: 10.8498,
    y2: 48.1262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_125_30185",
    x1: 22.8328,
    y1: 58.5764,
    x2: 10.8498,
    y2: 58.5764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_125_30185",
    x1: 10.8494,
    y1: 6.32491,
    x2: -1.13321,
    y2: 6.32491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_125_30185",
    x1: 10.8494,
    y1: 16.7752,
    x2: -1.13321,
    y2: 16.7752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_125_30185",
    x1: 10.8494,
    y1: 27.2257,
    x2: -1.13321,
    y2: 27.2257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_125_30185",
    x1: 10.8494,
    y1: 37.6761,
    x2: -1.13321,
    y2: 37.6761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_125_30185",
    x1: 10.8494,
    y1: 48.1262,
    x2: -1.13321,
    y2: 48.1262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_125_30185",
    x1: 10.8494,
    y1: 58.5764,
    x2: -1.13321,
    y2: 58.5764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D4D4D",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999838,
    stopColor: "#464646",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6149,
    stopColor: "#262626",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#1A1A1A",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_125_30185",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.8231 32.4506) scale(52.3716 28.7485)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.98
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_125_30185",
    x1: 13.3771,
    y1: 21.6822,
    x2: 22.6261,
    y2: 21.6822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656564"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_125_30185",
    x1: 19.5427,
    y1: 40.1799,
    x2: 38.0406,
    y2: 40.1799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656564"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_125_30185",
    x1: 34.9576,
    y1: 21.6822,
    x2: 44.2065,
    y2: 21.6822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#656564"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_30185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 63,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.ce26fe94bd14badc8eba76e8f07fa9fd.svg";
export { ForwardRef as ReactComponent };